import { redirect } from '@/helpers/redirects';
import { FETCH_PARENT_REGISTRATION } from '@/graphql/account/queries';

export default async function redirectParentRegistration(apolloProvider) {
  try {
    const { data } = await apolloProvider.defaultClient.query({
      query: FETCH_PARENT_REGISTRATION,
    });
    const { postalAddress, careType } = data.parentRegistration;
    const { pathname, search } = new URL(window.location.href);
    const returnPath = pathname + search;

    if (!postalAddress) {
      redirect(`/registration/location?returnPath=${encodeURIComponent(returnPath)}`);
      return;
    }
    if (!careType && window.location.pathname === '/account/seekers/dashboard') {
      redirect('/registration/care_type');
    }
  } catch (err) {
    console.error('Error fetching parent registration:', err);
    throw err;
  }
}
